const GOOGLE_TAG_SCRIPT_ID = 'mindware-google-tag-script';

export const getGoogleTagId = () => process.env.REACT_APP_GTAG_ID?.trim();

export const initGoogleTag = (tagId) => {
  if (!tagId || typeof document === 'undefined' || typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  if (!document.getElementById(GOOGLE_TAG_SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = GOOGLE_TAG_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(tagId)}`;
    document.head.appendChild(script);
  }

  window.__mindwareGoogleTagIds = window.__mindwareGoogleTagIds || {};

  if (window.__mindwareGoogleTagIds[tagId]) {
    return;
  }

  window.gtag('js', new Date());
  window.gtag('config', tagId, {
    anonymize_ip: true,
    send_page_view: false,
  });
  window.__mindwareGoogleTagIds[tagId] = true;
};

export const trackGooglePageView = (tagId) => {
  if (!tagId || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', 'page_view', {
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}`,
  });
};
